import AccommodationRoomDetailsModal from 'components/AccommodationKit/AccommodationRoomDetailsModal'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import { isHotelPackage } from 'lib/offer/offerTypes'
import LoyaltyTierBenefitMessageBanner from 'loyalty/components/LoyaltyTierBenefitMessageBanner'
import getLoyaltyTargetUpgradePackage from 'loyalty/lib/getLoyaltyTargetUpgradePackage'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import TextLink from 'LuxKit/TextLink'
import React, { useCallback, useContext } from 'react'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import OfferPageLoyaltyStayUpgradeCallOutBannerSwitch from './OfferPageLoyaltyStayUpgradeCallOutBannerSwitch'

interface Props {
  packageView: OfferPackageOptionView;
  offer: App.Offer;
}

function OfferPageLoyaltyStayUpgradeCallOutBanner({
  packageView,
  offer,
}: Props) {
  const { package: pkg } = packageView
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const showModal = useContext(ModalContext)
  const targetUpgradePackage = getLoyaltyTargetUpgradePackage(offer, pkg)

  const showTargetUpgradeRoomDetails = useCallback(() => {
    if (!targetUpgradePackage || !isHotelPackage(targetUpgradePackage)) return
    showModal(<AccommodationRoomDetailsModal
      roomPackage={targetUpgradePackage}
    />)
  }, [showModal, targetUpgradePackage])

  if (!packageView.hasLoyaltyTargetUpgradeAvailable || !targetUpgradePackage) return null

  return <ProductPaletteProvider palette={`tier-${tier}`}>
    <LoyaltyTierBenefitMessageBanner
      tier={tier}
      benefitType="hotel_upgrade"
      endContent={<OfferPageLoyaltyStayUpgradeCallOutBannerSwitch package={pkg} />}
    >
      <Group direction="vertical" tabletDirection="horizontal" tabletGap="0 24" wrap="wrap">
        <CSSBreakpoint max="tablet">Apply free room upgrade</CSSBreakpoint>
        <CSSBreakpoint min="desktop">
          <Group direction="horizontal" gap={8}>
            <div>Apply free room upgrade to</div>
            <b>{targetUpgradePackage.roomType?.name ?? targetUpgradePackage.name}</b>
          </Group>
        </CSSBreakpoint>
        <TextLink size="caption" onClick={showTargetUpgradeRoomDetails}>View upgraded room</TextLink>
      </Group>
    </LoyaltyTierBenefitMessageBanner>
  </ProductPaletteProvider>
}

export default withMountGuard(() => useAppSelector(getIsLoyaltyEnabled))(
  withOfferPageAndReduxState((state) => ({
    offer: state.offer,
  }), OfferPageLoyaltyStayUpgradeCallOutBanner),
)
